import { Component } from '@angular/core';
import * as Constants from '@shared/_constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-keyword-screening-info-dialog',
  templateUrl: './keyword-screening-info-dialog.component.html',
  styleUrls: ['./keyword-screening-info-dialog.component.css'],
})
export class KeywordScreeningInfoDialogComponent {
  constructor(private activeModal: NgbActiveModal) {}

  closeClick() {
    this.activeModal.close(Constants.ConfirmationResult.yes);
  }
}
